
import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Layout from './components/Layout'
import Home from './pages/Home'
import Exercises from './pages/Exercises'
import Programs from './pages/Programs'
import Nutrition from './pages/Nutrition'
import Resources from './pages/Resources'
import Products from './pages/Products'
import Subscription from './pages/Subscription'
import PaymentSuccess from './pages/PaymentSuccess'
import Help from './pages/Help'
import Legal from './pages/Legal'
import Booking from './pages/Booking'
import Contact from './pages/Contact'
import Admin from './pages/Admin'
import ForceEmail from './pages/ForceEmail'

function App() {
  return (
    <Router>
      <div className="min-h-screen relative">
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/exercices" element={<Exercises />} />
            <Route path="/programmes" element={<Programs />} />
            <Route path="/nutrition" element={<Nutrition />} />
            <Route path="/ressources" element={<Resources />} />
            <Route path="/produits" element={<Products />} />
            <Route path="/abonnement" element={<Subscription />} />
            <Route path="/paiement-confirme" element={<PaymentSuccess />} />
            <Route path="/aide" element={<Help />} />
            <Route path="/mentions-legales" element={<Legal />} />
            <Route path="/reservation" element={<Booking />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/force-email" element={<ForceEmail />} />
          </Routes>
        </Layout>
        <Toaster 
          position="top-right"
          toastOptions={{
            style: {
              background: '#1f2937',
              color: '#fff',
            },
          }}
        />
      </div>
    </Router>
  )
}

export default App
